/**
 * Synchronizes custom product availability UI with the theme's add-to-cart state.
 */
(function() {
  'use strict';

  const selectors = {
    product: '[data-section-type="product"]',
    addToCart: '[data-product-form] [data-add-to-cart]',
    backInStock: '[data-klaviyo-bis-trigger]',
    shippingBar: '[data-shipping-bar]',
    inventoryCounter: '[data-inventory-counter]',
    quantityGroup: '.product__controls-group-quantity'
  };

  function placeInventoryCounter(product) {
    const inventoryCounter = product.querySelector(selectors.inventoryCounter);
    const quantityGroup = product.querySelector(selectors.quantityGroup);
    if (!inventoryCounter || !quantityGroup) return;

    quantityGroup.appendChild(inventoryCounter);
    quantityGroup.classList.add('product__controls-group-quantity--with-inventory');
  }

  function setTriggerAvailability(trigger, available) {
    trigger.classList.toggle('hidden', available);
    trigger.hidden = available;
    trigger.setAttribute('aria-hidden', available ? 'true' : 'false');

    if (available) {
      trigger.setAttribute('tabindex', '-1');
    } else {
      trigger.style.removeProperty('display');
      trigger.removeAttribute('tabindex');
    }
  }

  function showOutOfStockInventory(product) {
    const inventoryCounter = product.querySelector(selectors.inventoryCounter);
    if (!inventoryCounter) return;

    if (inventoryCounter.classList.contains('hidden')) {
      inventoryCounter.classList.remove('hidden');
    }
    if (inventoryCounter.dataset.stockCategory !== 'empty') {
      inventoryCounter.dataset.stockCategory = 'empty';
    }

    const message = inventoryCounter.querySelector('.inventory-counter__message');
    if (
      message &&
      inventoryCounter.dataset.soldOutText &&
      message.textContent !== inventoryCounter.dataset.soldOutText
    ) {
      message.textContent = inventoryCounter.dataset.soldOutText;
    }

    const progress = inventoryCounter.querySelector('.inventory-counter__bar-progress');
    if (progress && progress.style.width !== '0%') progress.style.width = '0%';
  }

  function updateProduct(product) {
    const addToCart = product.querySelector(selectors.addToCart);
    if (!addToCart) return;

    const available = !addToCart.disabled;
    product.classList.toggle('product-availability--out-of-stock', !available);

    if (!available) showOutOfStockInventory(product);

    product.querySelectorAll(selectors.backInStock).forEach(function(trigger) {
      setTriggerAvailability(trigger, available);
    });

    product.querySelectorAll(selectors.shippingBar).forEach(function(shippingBar) {
      shippingBar.dataset.productAvailable = available ? 'true' : 'false';
    });

    if (window.shippingBar && typeof window.shippingBar.updateAllBars === 'function') {
      window.shippingBar.updateAllBars();
    }
  }

  function observeProduct(product) {
    if (product.dataset.availabilityUiInitialized === 'true') return;

    const addToCart = product.querySelector(selectors.addToCart);
    if (!addToCart) return;

    product.dataset.availabilityUiInitialized = 'true';
    placeInventoryCounter(product);
    updateProduct(product);

    const observer = new MutationObserver(function() {
      updateProduct(product);
    });

    observer.observe(addToCart, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });

    const inventoryCounter = product.querySelector(selectors.inventoryCounter);
    if (inventoryCounter) {
      const inventoryObserver = new MutationObserver(function() {
        if (addToCart.disabled) showOutOfStockInventory(product);
      });

      inventoryObserver.observe(inventoryCounter, {
        attributes: true,
        attributeFilter: ['class', 'data-stock-category'],
        childList: true,
        subtree: true
      });
    }
  }

  function init(root) {
    const scope = root || document;

    if (scope.matches && scope.matches(selectors.product)) {
      observeProduct(scope);
    }

    scope.querySelectorAll(selectors.product).forEach(observeProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });
})();
